module.exports = __webpack_public_path__ + "static/media/IMG_20191127_133854.e95cc22f.jpg";